export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 2,
				text: "Die Ziele waren für mich gut nachvollziehbar.",
			},
			{
				id: 3,
				text: "Die Veranstaltung war übersichtlich und verständlich",
			},
			{
				id: 4,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 5,
				text: "Ich wurde zum Mitdenken motiviert.",
			},
			{
				id: 6,
				text: "Ich habe mich schon vor der Veranstaltung für das Thema interessiert.",
			},
			{
				id: 7,
				text: "Das Thema der Veranstaltung ist als solches relevant.",
			},
			{
				id: 8,
				text: "Die Veranstaltung ist für mich ein wichtiger Bestandteil des universitären Weiterbildungsprogrammes für Doktoranden (GradUS).",
			},
			{
				id: 9,
				text: "Die Veranstaltung hat mich in der Auffassung bestärkt, dass das Thema für meine berufliche Laufbahn relevant ist.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 10,
				text: "Die Schwere des Stoffes war...",
			},
			{
				id: 11,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 12,
				text: "Das Tempo der Veranstaltung war...",
			},
			{
				id: 13,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
			{
				id: 14,
				text: "Insgesamt empfand ich die Veranstaltung als...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 15,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 16,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 17,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
			{
				id: 18,
				text: "Die Referent/innen waren engagiert und motiviert.",
			},
			{
				id: 19,
				text: "Ich habe mich gut durch die Veranstaltung geleitet gefühlt.",
			},
			{
				id: 20,
				text: "Ich konnte dem Tempo der Referent/innen gut folgen.",
			},
			{
				id: 21,
				text: "Die Referent/innen ermöglichten eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 22,
				text: "Die Referent/innen gaben mir die Möglichkeit, mich an der Bearbeitung des Themas zu beteiligen.",
			},
			{
				id: 23,
				text: "Die Referent/innen waren gut vorbereitet.",
			},
			{
				id: 24,
				text: "Die Referent/innen konnten in angemessenem Umfang flexibel auf die Wünsche und Bedürfnisse der Teilnehmenden eingehen.",
			},
			{
				id: 25,
				text: "Die Referent/innen waren fachlich kompetent.",
			},
			{
				id: 26,
				text: "Die Referent/innen konnten gut erklären.",
			},
			{
				id: 27,
				text: "Den Referent/innen war es wichtig, dass die Teilnehmer/innen etwas lernen.",
			},
			{
				id: 28,
				text: "Die Referent/innen motivierten die Teilnehmer/innen.",
			},
			{
				id: 29,
				text: "Die vermittelten Kompetenzen sind für meine berufliche und/oder persönliche Entwicklung relevant.",
			},
			{
				id: 30,
				text: "Ich habe das Gefühl, in der Veranstaltung wichtige Kompetenzen weiterentwickelt zu haben.",
			},
			{
				id: 31,
				text: "Ich kann jetzt das Thema selbstständig weiterbearbeiten.",
			},
			{
				id: 32,
				text: "Ich hatte Gelegenheit, meine Themen und Anliegen zu reflektieren.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 33,
				text: "Welche Anregungen haben Sie bezogen auf diese Veranstaltung (Lob/Kritik)?",
			},
			{
				id: 34,
				text: "Welche Themen wünschen Sie sich für zukünftige GradUS-Veranstaltungen?",
			},
		],
	},
	{
		type: "special",
		id: 5,
		items: [
			{
				id: 35,
				text: "In welcher Phase Ihrer Promotion befinden Sie sich?",
				label: [
					{
						id: 1,
						text: "Anfangsphase",
					},
					{
						id: 2,
						text: "Mittelphase",
					},
					{
						id: 3,
						text: "Endphase",
					},
				],
			},
		],
	},
];
